// Country code to flag file name mapping
const countryCodeToFlag: Record<string, string> = {
  '1': 'united-states', // US/Canada
  '84': 'vietnam', // Vietnam
  '86': 'china', // China
  '81': 'japan', // Japan
  '82': 'south-korea', // South Korea
  '44': 'united-kingdom', // UK
  '33': 'france', // France
  '49': 'germany', // Germany
  '39': 'italy', // Italy
  '34': 'spain', // Spain
  '61': 'australia', // Australia
  '91': 'india', // India
  '65': 'singapore', // Singapore
  '60': 'malaysia', // Malaysia
  '66': 'thailand', // Thailand
  '62': 'indonesia', // Indonesia
  '63': 'philippines', // Philippines
  '886': 'taiwan', // Taiwan
  '852': 'hong-kong', // Hong Kong
  '7': 'russia', // Russia
  '55': 'brazil', // Brazil
  '52': 'mexico', // Mexico
  '27': 'south-africa', // South Africa
  '20': 'egypt', // Egypt
  '971': 'united-arab-emirates', // UAE
  '966': 'saudi-arabia', // Saudi Arabia
  '90': 'turkey', // Turkey
  '48': 'poland', // Poland
  '31': 'netherlands', // Netherlands
  '32': 'belgium', // Belgium
  '41': 'switzerland', // Switzerland
  '43': 'austria', // Austria
  '45': 'denmark', // Denmark
  '46': 'sweden', // Sweden
  '47': 'norway', // Norway
  '358': 'finland', // Finland
  '351': 'portugal', // Portugal
  '30': 'greece', // Greece
  '420': 'czech-republic', // Czech Republic
  '36': 'hungary', // Hungary
  '40': 'romania', // Romania
  '353': 'ireland', // Ireland
  '64': 'new-zealand', // New Zealand
  '54': 'argentina', // Argentina
  '56': 'chile', // Chile
  '57': 'colombia', // Colombia
  '51': 'peru', // Peru
  '58': 'venezuela', // Venezuela
}

/**
 * Get country flag image path from phone number
 * @param phoneNumber - Phone number (can start with + or not)
 * @returns Flag image path or default flag (united-states)
 */
export const getCountryFlagFromPhone = (phoneNumber: string): string => {
  const defaultFlag = '/media/flags/united-states.svg'

  if (!phoneNumber) return defaultFlag

  // Remove all non-digit characters
  const cleaned = phoneNumber.replace(/\D/g, '')

  // Try to match country codes from longest to shortest
  const sortedCodes = Object.keys(countryCodeToFlag).sort((a, b) => b.length - a.length)

  for (const code of sortedCodes) {
    if (cleaned.startsWith(code)) {
      return `/media/flags/${countryCodeToFlag[code]}.svg`
    }
  }

  // Default to US flag if no match found
  return defaultFlag
}
